import { IContact } from 'clickNgo/entities/contact'
import { I375Form } from 'clickNgo/models/crud/forms'

const externalFieldNames: { [key in keyof Partial<I375Form>]: keyof IContact } = {
  CountryOfBusiness: 'countryOfBusiness',
  Email: 'email',
  EmailPixels: 'emailPixels',
  FirstName: 'firstName',
  LastName: 'lastName',
  MobilePhone: 'mobilePhoneNumber',
  MobilePhone_Prefix: 'mobilePhoneCode',
  NeverCall: 'isNeverCall',
  NeverEmail: 'isNeverEmail',
  PR_HP_ROLE: 'hpRoles',
  PreferredLanguage: 'preferredLanguage',
  Salutation: 'salutation',
  Seniority: 'seniority',
  Status: 'status',
  WorkPhone: 'workPhoneNumber',
  WorkPhone_Prefix: 'workPhoneCode',
  ModifiedValues: 'modifiedValues',
  PrimaryJobRole: 'primaryJobRole',
}

export const mapContactModifiedValues = (
  modifiedValues: Array<keyof Partial<I375Form>>
): string[] =>
  modifiedValues.reduce<Array<keyof IContact>>((acc, key) => {
    if (externalFieldNames[key]) {
      acc.push(externalFieldNames[key] as keyof IContact)
    }
    return acc
  }, [])
